import styled from 'styled-components';

export const PartyJackpotInGameWidgetContentContainerBox = styled.div`
    width: 100%;
    overflow: hidden;
    position: absolute;
    bottom: 5px;

    @media ${(props) => props.theme.mediaQuery.xlExact} {
        bottom: 3px;
    }

    @media ${(props) => props.theme.mediaQuery.lAndBelow} {
        bottom: 3px;
    }
`;
